import {
    addDoc,
    collection,
    deleteDoc,
    doc,
    getDocs,
    updateDoc,
    query,
    orderBy,
    onSnapshot
} from '@firebase/firestore';
import { getDownloadURL, getStorage, ref, uploadBytesResumable, deleteObject } from '@firebase/storage';
import firebaseHelper from '../helper/firebaseHelper';
import mapLoader from '../helper/mapLoader';
import { getFunctions, httpsCallable } from 'firebase/functions';

//todo create instance on constructor

let _fileUrlList = [];
export class BaseService {
    // get(id: string): <T>;
    // list(): <T[]>;
    // add(item: T): Promise<T>;
    // update(item: T): Promise<T>;
    // delete(id: string): void;

    constructor(collectionName) {
        const firebaseHelp = new firebaseHelper();
        if (!firebaseHelp.getStatus()) {
            this.status = false;
            return;
        }

        this.status = true;
        let tenant = firebaseHelp.getTenant();
        let dbName = firebaseHelp.getdbName();
        this.tenant = tenant;
        this.dbName = dbName;
        this.collectionName = dbName + '/' + tenant + '/' + collectionName;
        this.app = firebaseHelp.initialize();
        this.db = firebaseHelp.getDb();
    }

    collectionName;
    db;
    tenant;

    //Get List of collection
    async getList(order = null) {

        if (!this.status)
            return [];
        let colRef = collection(this.db, this.collectionName);
        if (order) colRef = query(colRef, orderBy(order, 'desc'));

        const listSnapshot = await getDocs(colRef);
        let result = [];

        for (const doc of listSnapshot.docs) {
            result.push({ ...doc.data(), recordId: doc.id });
        }
        return result;

    }

    async addDocument(obj) {
        try {
            const colRef = collection(this.db, this.collectionName);
            const docRef = await addDoc(colRef, obj);
            console.log('Document written with ID: ', docRef.id);
            obj.recordId = docRef.id;
            return obj;
        } catch (e) {
            console.error('Error adding document: ', e);
            return null;
        }
    }

    async updateDocument(data, id) {
        // await deleteDoc(doc(this._db, collectionName, docId));

        const docRef = doc(this.db, this.collectionName, id);
        console.log(docRef);
        // const data = { Label: "Test 111" };
        updateDoc(docRef, data)
            .then(() => {
                console.log('Updated successfully');
            })
            .catch((error) => {
                console.log(error);
            });
    }

    async deleteDocument(id) {
        // await deleteDoc(doc(this._db, collectionName, docId));

        const docRef = doc(this.db, this.collectionName, id);
        deleteDoc(docRef).then(() => { });
        return;
    }

    async deleteImage(path) {
        const storage = getStorage();
        const storageRef = ref(storage, this.tenant + '/' + path);

        deleteObject(storageRef).then(() => {
            console.log('image deleted');
        });

        return;
    }

    subscribe(callback) {
        let colRef = collection(this.db, this.collectionName);
        const unsub = onSnapshot(colRef, (result) => {
            callback ? callback(result) : null;
        });
        this.unsub = unsub;
    }

    unsubscribe() {
        this.unsub();
    }
    async uploadImage(file, path, meta) {
        let myPromise;
        mapLoader().open();

        myPromise = new Promise((resolve) => {
            // Create a root reference
            const storage = getStorage();
            // var storageRef = storage().ref();
            // Create a reference to 'mountains.jpg'
            const storageRef = ref(storage, this.tenant + '/' + path);

            // var metadata = {
            //     'name': label,
            //     customMetadata: meta,
            //     'contentType': file.type
            // };

            const uploadTask = uploadBytesResumable(storageRef, file, meta);
            // const uploadTask = uploadBytes(storageRef, file,metadata);

            uploadTask.on(
                'state_changed',
                (snapshot) => {
                    // Observe state change events such as progress, pause, and resume
                    // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                    const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
                    console.log('Upload is ' + progress + '% done');
                    switch (snapshot.state) {
                        case 'paused':
                            console.log('Upload is paused');
                            break;
                        case 'running':
                            console.log('Upload is running');
                            break;
                    }
                },
                (error) => {
                    resolve(false);
                    switch (error.code) {
                        case 'storage/unauthorized':
                            console.log("User doesn't have permission to access the object");
                            break;
                        case 'storage/canceled':
                            console.log('User canceled the upload');
                            break;
                        case 'storage/unknown':
                            console.log('Unknown error occurred, inspect error.serverResponse');
                            break;
                    }
                },
                () => {
                    resolve(true);
                    // Handle successful uploads on complete
                    // For instance, get the download URL: https://firebasestorage.googleapis.com/...
                    // getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                    //     console.log('File available at', downloadURL);
                    // });
                }
            );
        });

        myPromise.then((value) => {
            mapLoader().close();
            console.log(value);
            return value;
        });

        return myPromise;
    }

    async getUrl(path) {
        const storage = getStorage();
        return getDownloadURL(ref(storage, this.tenant + '/' + path));
        // .then((url) => {
        //     return url;
        // })
    }

    async getFileUrl(path) {

        let found = false;
        let foundUrl = "";
        //check if we have url already
        _fileUrlList.forEach((obj) => {
            if (obj.path == path) {
                found = true;
                foundUrl = obj.generatedUrl;
                return;
            }
        });

        if (!found) {
            let url = await this.downloadImage(path);
            let generatedUrl = URL.createObjectURL(url);
            _fileUrlList.push({ path: path, generatedUrl: generatedUrl });
            return generatedUrl;
        } else {
            return foundUrl;
        }
    }

    async downloadImage(path) {
        mapLoader().open();
        const storage = getStorage();

        return await getDownloadURL(ref(storage, this.tenant + '/' + path))
            .then((url) => {
                let myPromise;

                myPromise = new Promise((resolve) => {
                    const xhr = new XMLHttpRequest();
                    xhr.responseType = 'blob';

                    xhr.onload = () => {
                        const blob = xhr.response;
                        return resolve(blob);
                    };
                    xhr.onerror = (error) => {
                        console.log(error);
                        mapLoader().close();
                        return resolve(null);
                    };
                    xhr.open('GET', url);
                    xhr.send();
                });

                myPromise.then((value) => {
                    mapLoader().close();
                    console.log(value);
                    return value;
                });

                return myPromise;
            })
            .catch((error) => {
                console.log(error);
                mapLoader().close();

                return null;
            });
    }

    async callFunction(functionName, params) {
        let myPromise;
        mapLoader().open();
        let that = this;
        myPromise = new Promise((resolve) => {
            let functions = getFunctions(that.app);
            var callFunc = httpsCallable(functions, functionName);

            // call the function and pass data
            callFunc(params)
                .then((result) => {
                    resolve(result);
                })
                .catch((error) => {
                    console.log(error);
                    resolve(null);
                });
        });

        myPromise.then((value) => {
            mapLoader().close();
            console.log(value);
            return value;
        });

        return myPromise;
    }
}
